// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mc-0";